import { useMonitoreoPersonalStore } from "../../../../../store/monitoreoPersonal";
import { useEffect, useState } from "react";
import useMonitoreoPersonal from "../../../../../api/monitoreoPersonal";
import { Bar, BarChart, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { NavigateBeforeOutlined } from "@mui/icons-material";
import { getInteraccionesUnDiaHandler } from "../../../../../handlers/monitoreo.handler";
import { motion } from 'framer-motion';
import TablaInteraccionesUnDia from "../../components/TablaInteraccionesUnDia";
import { MuniSpinner2 } from "../../../../../components";
import { useGeneralAppStore } from "../../../../../store/generalAppStore";
import TablaInteraccionesBackOfficeUnDia from "../../components/TablaInteraccionesBackOfficeUnDia";

const InteraccionesPorUsuario = () => {
  const [fechaSolicitada, setFechaSolicitada] = useState(null);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
  const { personalMonitoreo, estadisticasPersona, setEstadisticasPersona, interaccionesUnDia, setInteraccionesUnDia, fechaSeleccionada } = useMonitoreoPersonalStore();
  const { getPersonalMonitoreo, getEstadisticasPersona } = useMonitoreoPersonal();
  const { setType } = useMonitoreoPersonalStore();
  const { loads } = useGeneralAppStore();

  useEffect(() => {
    if (!fechaSolicitada || !usuarioSeleccionado) return;

    if (fechaSolicitada && usuarioSeleccionado) {
      setEstadisticasPersona(null);

      getEstadisticasPersona({
        user_id: usuarioSeleccionado,
        fecha_solicitada: fechaSolicitada,
      });
    }
  }, [fechaSolicitada, usuarioSeleccionado]);

  const handleSeleccionFecha = (e) => {
    setFechaSolicitada(e.target.value);
  };


  const CustomYAxisTick = ({ x, y, payload, data }) => {
    const rowData = data.find(item => item.nombre === payload.value);

    return (
      <text
        x={x}
        y={y}
        dy={4}
        textAnchor="end"
        fill="#666"
        fontSize={14}
        fontWeight="bold"
        style={{ cursor: "pointer" }}
        onClick={() => {
        }}
      >
        {payload.value}
      </text>
    );
  };


  const coloresBarras = ["#8884d8", "#82ca9d", "#ffc658"]; // Colores personalizados

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          padding: "10px",
          borderRadius: "5px",
          color: "#fff",
        }}>
          <p className="fs-4">{payload[0]?.payload.dia_semana || payload[0]?.payload.mes}</p>
          <p style={{ color: "#fff" }}>{payload[0]?.name}: {payload[0]?.value}</p>
          {/* <p style={{ color: payload[1]?.color }}>{payload[1]?.name}: {payload[1]?.value}</p> */}
        </div>
      );
    }
    return null;
  };

  useEffect(() => {
    return () => {
      setInteraccionesUnDia(null)
    }
  }, [])

  return (
    <>

      <div className="mt-4  d-flex justify-content-center w-100">
        <div className="col-2">
          <section className="d-flex flex-column gap-5 align-items-center mt-3 px-5">
            <button className="btn btn-primary btn-sm" onClick={() => { setType('general') }}> <NavigateBeforeOutlined />{" Volver"}</button>
            <div className="d-flex flex-column gap-3 bg-primary p-5 py-4 rounded-4 text-white shadow-lg">
              <div className="d-flex flex-column ">
                <h5 className="text-white mb-0">Agente</h5>
                <hr className="my-2"/>
                <p className="m-0 font-bold " style={{ fontSize: "16px" }}>Nombre: </p>
                <span className="fw-light">{estadisticasPersona?.usuario?.nombre}</span>
              </div>
              <div className="d-flex flex-column">
                <p className="m-0 font-bold " style={{ fontSize: "16px" }}>Email: </p>
                <span className="fw-light">{estadisticasPersona?.usuario?.email}</span>
              </div>
              <div className="d-flex flex-column">
                <p className="m-0 font-bold " style={{ fontSize: "16px" }}>Documento: </p>
                <span className="fw-light">{estadisticasPersona?.usuario?.documento}</span>
              </div>
            </div>
          </section>

        </div >
        <div className=" col-8">
          <div className="position-relative w-100 ">
            {
              loads.includes("interacciones_de_un_dia") &&
              <div className="position-absolute top-0  w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: "rgba(255,255,255,0.8)", zIndex: "999" }}>
                <MuniSpinner2 />
              </div>
            }
            <section>
              <div className="mb-0" style={{ height: "40vh" }}>
                {/* <section className="d-flex gap-5 align-items-center mt-3 px-5">
                  <button className="btn btn-primary btn-sm" onClick={() => { setType('general') }}> <NavigateBeforeOutlined />{" Volver"}</button>
                  <h5 className="text-center m-0">Interacciones por día</h5>
                  <p className="m-0 font-bold " style={{ fontSize: "16px" }}>Nombre: <span className="fw-medium">{estadisticasPersona?.usuario?.nombre}</span></p>
                  <p className="m-0 font-bold " style={{ fontSize: "16px" }}>Email: <span className="fw-medium">{estadisticasPersona?.usuario?.email}</span></p>
                  <p className="m-0 font-bold " style={{ fontSize: "16px" }}>Documento: <span className="fw-medium">{estadisticasPersona?.usuario?.documento}</span></p>
                </section> */}

                {
                  estadisticasPersona?.interacciones_dia &&

                  <ResponsiveContainer width="90%" height={"100%"} className={'mx-auto'}>
                    <ComposedChart
                      width={500}
                      height={200}
                      data={estadisticasPersona?.interacciones_dia}
                      margin={{ top: 30, right: 30, left: 20, bottom: 0 }}
                    >
                      <text x="50%" y="10" textAnchor="middle" dominantBaseline="middle" fontSize="18" fontWeight="bold">
                        Interacciones por día
                      </text>
                      <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
                      <XAxis dataKey="dia_semana" type="category" />
                      {/* <YAxis type="number" dataKey={'total_interacciones'} /> */}
                      <YAxis />
                      <Tooltip content={<CustomTooltip />} />
                      <Bar dataKey={"total_interacciones"} barSize={20} fill="#413ea0" onClick={(params) => {
                        getInteraccionesUnDiaHandler({ user_id: estadisticasPersona?.usuario?.id, fecha: params.fecha })
                      }
                      }
                      />
                      <Line type={"monotone"} dataKey={"total_interacciones"} stroke="#ff7300" />
                    </ComposedChart>
                  </ResponsiveContainer>
                }
              </div>
            </section>
            <motion.section
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: interaccionesUnDia ? "500px" : 0, opacity: interaccionesUnDia ? 1 : 0 }}
              transition={{ duration: 0.4, ease: "easeInOut" }}
              className="d-flex  mx-auto d-flex mb-4"
              style={{ width: "85%" }}
            >
              {
                // interaccionesUnDia?.interacciones &&
                <div className="col-7 px-2">
                  <p className="m-2 fw-bold text-primary">Interacciones MVD</p>
                  <TablaInteraccionesUnDia />
                </div>
              }
              {
                // interaccionesUnDia?.interacciones_backoffice &&
                <div className="col-5 px-2">
                  <p className="m-2 fw-bold text-primary">Interacciones BackOffice</p>
                  <TablaInteraccionesBackOfficeUnDia />
                </div>
              }
            </motion.section>
          </div>
          <hr />
          <section>
            <div style={{ height: "40vh" }}>
              {
                estadisticasPersona?.interacciones_mes &&

                <ResponsiveContainer width="90%" height={"100%"} className={'mx-auto'}>
                  <ComposedChart
                    width={500}
                    height={200}
                    data={estadisticasPersona?.interacciones_mes}
                    margin={{ top: 30, right: 30, left: 20, bottom: 0 }}
                  >
                    <text x="50%" y="10" textAnchor="middle" dominantBaseline="middle" fontSize="18" fontWeight="bold">
                      Interacciones por mes
                    </text>
                    <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
                    <XAxis dataKey="mes" type="category" />
                    {/* <YAxis dataKey="nombre" type="category" tick={{ fill: '#666', fontSize: 14, fontWeight: "bold" }} width={150} /> */}
                    <YAxis type="number" dataKey={'total_interacciones'} />
                    <Tooltip content={<CustomTooltip />} />

                    <Bar dataKey={"total_interacciones"} barSize={20} fill="#413ea0" onClick={(params) => console.log(params)} />

                    <Line type={"monotone"} dataKey={"total_interacciones"} stroke="#ff7300" />

                  </ComposedChart>
                </ResponsiveContainer>
              }
            </div>
          </section>
        </div>
      </div >
    </>
  );
};
export default InteraccionesPorUsuario;
